const dataPrefix = "data-validation";
const msgSuffix = "--msg";

export const dataValidation = {
    novalidation: {
        prefix: `${dataPrefix}-novalidation`,
        get msg() {
            return this.prefix + msgSuffix;
        }
    },
    required: {
        prefix: `${dataPrefix}-required`,
        get msg() {
            return this.prefix + msgSuffix;
        }
    },
    invalid: {
        prefix: `${dataPrefix}-invalid`,
        get msg() {
            return this.prefix + msgSuffix;
        }
    },
    length: {
        prefix: `${dataPrefix}-length`,
        get msg() {
            return this.prefix + msgSuffix;
        }
    },
    value: {
        prefix: `${dataPrefix}-value`,
        get msg() {
            return this.prefix + msgSuffix;
        }
    },
    group: {
        prefix: `${dataPrefix}-group`,
        get msg() {
            return this.prefix + msgSuffix;
        }
    },
    regex: {
        prefix: `${dataPrefix}-regex`,
        get msg() {
            return this.prefix + msgSuffix;
        }
    }
};
